import produce from 'immer';

import {
  FETCH_MERGE_CODES_FAILURE,
  FETCH_MERGE_CODES_SUCCESS,
  FETCH_XERCE_MERGE_CODES_FAILURE,
  FETCH_XERCE_MERGE_CODES_SUCCESS,
} from '@actions/mergeCode';

const initialState: IMergeCodeStore = {
  xerceMergeCode: null,
  mergeCode: null,
  error: null,
};

export default (state: IMergeCodeStore = initialState, action: any) =>
  produce(state, (draftState: IMergeCodeStore) => {
    switch (action.type) {
      case FETCH_XERCE_MERGE_CODES_FAILURE:
      case FETCH_MERGE_CODES_FAILURE:
        draftState.error = action.error;

        return;

      case FETCH_XERCE_MERGE_CODES_SUCCESS:
        draftState.xerceMergeCode = action.response;
        draftState.error = null;

        return;

      case FETCH_MERGE_CODES_SUCCESS:
        draftState.mergeCode = action.response;
        draftState.error = null;

        return;
    }
  });
